/** 菜单管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/sys/menu';
/**
 * 分页查询
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Sys.Menu> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询菜单列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Sys.Menu> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个菜单
 *
 * @param id 菜单ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Sys.Menu> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存菜单
 *
 * @param params 菜单信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新菜单信息
 *
 * @param params 菜单信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除菜单
 *
 * @param id 菜单ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除菜单
 *
 * @param ids 菜单ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
